<template>
  <div class="kennzahlen_left">
    <h3>Kennzahlen</h3>
    <table>
      <tr v-for="row in data">
        <td>{{ row[2] }}</td>
        <td>
          {{
            row[4].toLocaleString("de-DE", {
              minimumFractionDigits: 0,
            })
          }}<span v-if="row[3] !== '€' && row[3] !== '%'">&nbsp;</span>{{ row[3] }}
        </td>
      </tr>
    </table>
  </div>
  <div class="kennzahlen_right">
    <h3>Veränderung zum VJQ</h3>
    <div>
      <!-- <table>
        <tr v-for="row in data">
          <td>
            {{ row[5] > 0 ? "+ " : "- "
            }}{{
              Math.abs(row[5]).toLocaleString("de-DE", {
                minimumFractionDigits: 0,
              })
            }}
          </td>
        </tr>
      </table> -->
      <!-- <Bar
        :chart-options="chartOptions"
        :chart-data="chartData"
        chart-id="kz_veraenderung"
        cssClasses="kz_chart_wrapper"
      /> -->
      <canvas
        id="kz_veraenderung"
        width="150"
        height="224"
        ref="chart"
      ></canvas>
    </div>
  </div>
</template>

<script>
import { ref, watch, onMounted } from "vue";
import ChartDataLabels from "chartjs-plugin-datalabels";
import annotationPlugin from "chartjs-plugin-annotation";

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
} from "chart.js";

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
  ChartDataLabels,
  annotationPlugin
);

ChartJS.defaults.font.family =
  'Calibri, Carlito, Candara, Segoe, "Segoe UI", Optima, Arial, sans-serif';

import { toolTipDefault } from "@/utils/settings";
import { colors } from "@/utils/config";

export default {
  name: "Kennzahlen",
  components: {},
  props: ["data", "options", "id", "inPrint", "inDownload"],
  setup(props) {
    const chart = ref();
    let chartRendered = false;
    let chartData;
    let rowLabels = [];
    const chartOptions = {
      maintainAspectRatio: true,
      responsive: false,
      indexAxis: "y",
      backgroundColor: colors.blue,
      categoryPercentage: 1.0,
      layout: {
        autoPadding: false,
        padding: {
          left: 0,
          right: 45,
          top: 0,
          bottom: 0,
        },
      },
      plugins: {
        autocolors: false,
        legend: {
          display: false,
        },
        tooltip: {
          ...toolTipDefault,
          callbacks: {
            title: function (context) {
              return rowLabels[context[0].dataIndex];
            },
            label: function (context) {
              return (
                (Math.round(context.raw * 100) / 100).toLocaleString("de-DE") +
                "%"
              );
            },
          },
        },
        datalabels: {
          color: "#304052",
          align: "right",
          anchor: "end",
          padding: {
            left: 0,
          },
          font: {
            size: 13,
            family:
              'Calibri, Carlito, Candara, Segoe, "Segoe UI", Optima, Arial, sans-serif',
            weight: 200,
          },
          formatter: (value, context) => {
            return value.toLocaleString("de-DE") + "%";
          },
        },
        annotation: {
      annotations: {
        line1: {
          drawTime: "afterDatasetsDraw",
          type: "line",
          mode: "vertical",
          scaleID: "x",
          value: 0,
          borderWidth: 1,
          borderColor: "black",
        },
      },
    },
      },
      scales: {
        x: {
          grid: {
            display: false,
            drawBorder: false,
          },
          ticks: {
            display: false,
          },
        },
        y: {
          grid: {
            display: false,
            drawBorder: false,
          },
          ticks: {
            display: false,
          },
        },
      },
    };

    onMounted(() => {
      updateDataset();
      createChart();
    });

    const createChart = () => {
      const options = {
        type: "bar",
        data: chartData,
        options: chartOptions,
      };
      if (!chartRendered) {
        chartRendered = new ChartJS(chart.value, options);
      }
    };

    const updateDataset = () => {
      const dataset = props.data.map((row) => row[6]);
      rowLabels = props.data.map((row) => row[2]);
      const colorsset = props.data.map((row) => {
        //return row[6] > 0 ? colors.green : colors.orange;
        return colors.blue
      });
      chartData = {
        datasets: [
          {
            data: dataset,
            backgroundColor: colorsset,
            barPercentage: 0.8,
            minBarLength: 3,
          },
        ],
        labels: dataset,
      };

      if (chartRendered) {
        chartRendered.data.labels.pop();
        chartRendered.data = chartData;
        chartRendered.update();
      }
    };

    watch(
      () => props.data,
      (val, prevVal) => {
        updateDataset();
      }
    );

    return {
      //chartOptions,
      //chartData,
      chart,
    };
  },
};
</script>

<style scoped>
#kz_veraenderung {
  display: inline-block;
  height: 224px;
  width: 140px;
  overflow: visible;
  margin-top: -5px;
}
</style>
